var _rect, _path, _polyline, _polyline2, _path2, _g, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "216px",
    height: "54px",
    viewBox: "0 84 216 54",
    enableBackground: "new 0 0 216 216",
    space: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 84,
    width: 216,
    height: 54,
    fill: "#3B3D40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    d: "M16.439,129.258H13.5v-33.8 c0,0,11.757-5.458,47.027-5.458c35.27,0,47.026,5.458,47.026,5.458v33.8h-2.939"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#CC6633",
    strokeWidth: 4,
    strokeLinecap: "round",
    points: "56.118,104.275  23.787,104.275 23.787,129.258 56.118,129.258  "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    points: "97.267,104.275 64.936,104.275  64.936,129.258 97.267,129.258 97.267,118.971 85.51,118.971  "
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC6633",
    d: "M124.688,106.214l-2.243,0.141c-0.031-1.29-0.535-1.936-1.51-1.936 c-1.119,0-1.679,0.994-1.679,2.98c0,1.147,0.152,1.925,0.457,2.334c0.304,0.408,0.729,0.612,1.274,0.612 c0.886,0,1.428-0.575,1.624-1.728l2.076,0.127c-0.134,1.094-0.541,1.926-1.222,2.494c-0.682,0.57-1.515,0.854-2.502,0.854 c-1.21,0-2.193-0.417-2.95-1.253c-0.757-0.834-1.135-1.988-1.135-3.462c0-1.38,0.366-2.509,1.099-3.389 c0.731-0.879,1.731-1.319,3-1.319C123.174,102.671,124.411,103.853,124.688,106.214z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CC6633",
    style: {
      transform: "translateX(1px)"
    },
    d: "M129.353,112.095c-1.23,0-2.184-0.462-2.857-1.386c-0.673-0.925-1.01-2.043-1.01-3.356 c0-1.335,0.341-2.449,1.023-3.342s1.655-1.34,2.918-1.34c1.275,0,2.238,0.477,2.887,1.43c0.649,0.953,0.974,2.044,0.974,3.271 c0,1.326-0.334,2.445-1.003,3.355C131.614,111.639,130.638,112.095,129.353,112.095z M129.413,104.419 c-1.123,0-1.685,0.987-1.685,2.96c0,1.978,0.562,2.967,1.685,2.967c1.087,0,1.631-0.987,1.631-2.96 C131.044,105.409,130.5,104.419,129.413,104.419z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC6633",
    style: {
      transform: "translateX(2px)"
    },
    d: "M141.72,102.812v9.142h-1.827l-3.578-6.175c0.005,0.156,0.009,0.259,0.014,0.308 c0.018,0.156,0.026,0.288,0.026,0.395v5.472h-1.667v-9.142h2.308l3.11,5.392c-0.027-0.268-0.04-0.471-0.04-0.609v-4.782H141.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC6633",
    style: {
      transform: "translateX(3px)"
    },
    d: "M149.348,102.812v1.809h-2.264v7.333h-2.17v-7.333h-2.277v-1.809H149.348z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC6633",
    style: {
      transform: "translateX(4px)"
    },
    d: "M152.422,108.331v3.623h-2.156v-9.142h4.018c0.741,0,1.337,0.086,1.785,0.258 c0.449,0.172,0.82,0.488,1.115,0.947s0.442,0.97,0.442,1.533c0,1.098-0.529,1.885-1.588,2.362l1.688,4.042h-2.366l-1.403-3.623 H152.422z M152.422,104.439v2.331h1.313c0.429,0,0.74-0.03,0.935-0.09c0.194-0.061,0.367-0.194,0.519-0.402 c0.152-0.208,0.228-0.446,0.228-0.713c0-0.254-0.075-0.482-0.228-0.683c-0.151-0.201-0.316-0.325-0.495-0.372 c-0.179-0.047-0.514-0.07-1.005-0.07H152.422z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC6633",
    style: {
      transform: "translateX(5px)"
    },
    d: "M163.771,102.812l2.862,9.142h-2.302l-0.563-1.882h-2.955l-0.573,1.882h-1.878 l2.931-9.142H163.771z M161.327,108.384h1.937l-0.96-3.208L161.327,108.384z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC6633",
    style: {
      transform: "translateX(6px)"
    },
    d: "M174.689,106.214l-2.243,0.141c-0.031-1.29-0.535-1.936-1.51-1.936 c-1.119,0-1.679,0.994-1.679,2.98c0,1.147,0.152,1.925,0.457,2.334c0.304,0.408,0.729,0.612,1.274,0.612 c0.886,0,1.428-0.575,1.624-1.728l2.076,0.127c-0.134,1.094-0.541,1.926-1.222,2.494c-0.682,0.57-1.515,0.854-2.502,0.854 c-1.21,0-2.193-0.417-2.95-1.253c-0.757-0.834-1.135-1.988-1.135-3.462c0-1.38,0.366-2.509,1.099-3.389 c0.731-0.879,1.731-1.319,3-1.319C173.176,102.671,174.413,103.853,174.689,106.214z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC6633",
    style: {
      transform: "translateX(7px)"
    },
    d: "M181.716,102.812v1.809h-2.264v7.333h-2.17v-7.333h-2.277v-1.809H181.716z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC6633",
    style: {
      transform: "translateX(8px)"
    },
    d: "M186.065,112.095c-1.23,0-2.184-0.462-2.857-1.386c-0.673-0.925-1.01-2.043-1.01-3.356 c0-1.335,0.341-2.449,1.023-3.342s1.655-1.34,2.918-1.34c1.275,0,2.238,0.477,2.887,1.43c0.649,0.953,0.974,2.044,0.974,3.271 c0,1.326-0.334,2.445-1.003,3.355C188.327,111.639,187.351,112.095,186.065,112.095z M186.126,104.419 c-1.123,0-1.685,0.987-1.685,2.96c0,1.978,0.562,2.967,1.685,2.967c1.087,0,1.631-0.987,1.631-2.96 C187.757,105.409,187.213,104.419,186.126,104.419z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC6633",
    style: {
      transform: "translateX(9px)"
    },
    d: "M193.557,108.331v3.623H191.4v-9.142h4.018c0.741,0,1.337,0.086,1.785,0.258 c0.449,0.172,0.82,0.488,1.115,0.947s0.442,0.97,0.442,1.533c0,1.098-0.529,1.885-1.588,2.362l1.688,4.042h-2.366l-1.403-3.623 H193.557z M193.557,104.439v2.331h1.313c0.429,0,0.74-0.03,0.935-0.09c0.194-0.061,0.367-0.194,0.519-0.402 c0.152-0.208,0.228-0.446,0.228-0.713c0-0.254-0.075-0.482-0.228-0.683c-0.151-0.201-0.316-0.325-0.495-0.372 c-0.179-0.047-0.514-0.07-1.005-0.07H193.557z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.407,122.271 v8.847",
    stroke: "red"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    d: "M130.407,121.771v9.347h-1.77c-0.128-0.622-0.312-1.256-0.552-1.902 c-1.18,1.438-2.684,2.156-4.511,2.156c-2.158,0-3.838-0.771-5.038-2.314s-1.8-3.539-1.8-5.986c0-2.634,0.64-4.751,1.92-6.351 c1.281-1.6,3.02-2.399,5.218-2.399c1.842,0,3.328,0.518,4.46,1.551c1.131,1.035,1.821,2.412,2.072,4.133l-3.685,0.484 c-0.299-2.003-1.248-3.005-2.848-3.005c-1.051,0-1.845,0.475-2.382,1.424c-0.537,0.95-0.806,2.305-0.806,4.065 c0,1.697,0.291,2.994,0.873,3.891c0.581,0.896,1.409,1.346,2.484,1.346c0.694,0,1.314-0.227,1.86-0.68 c0.545-0.451,0.817-1.175,0.817-2.168h-3.114v-3.091H130.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    d: "M141.735,114.574l5.178,16.543h-4.165l-1.019-3.405h-5.349l-1.037,3.405h-3.397 l5.303-16.543H141.735l5.178,16.543z M137.311,124.658h3.505l-1.737-5.806L137.311,124.658z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    d: "M152.597,124.561v6.557h-3.902v-16.543h7.271c1.341,0,2.418,0.156,3.229,0.467 c0.813,0.311,1.484,0.883,2.019,1.714c0.533,0.831,0.8,1.756,0.8,2.773c0,1.985-0.958,3.411-2.873,4.274l3.055,7.314h-4.282 l-2.54-6.557H152.597z M152.597,117.52v4.218h2.375c0.776,0,1.34-0.055,1.691-0.164c0.352-0.108,0.664-0.351,0.938-0.728 c0.275-0.375,0.412-0.805,0.412-1.29c0-0.46-0.137-0.872-0.412-1.236c-0.274-0.363-0.573-0.587-0.896-0.673 c-0.323-0.084-0.929-0.127-1.817-0.127H152.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    d: "M173.136,114.574l5.178,16.543h-4.165l-1.019-3.405h-5.349l-1.037,3.405h-3.397 l5.303-16.543H173.136l5.178,16.543z M168.711,124.658h3.505l-1.737-5.806L168.711,124.658z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    d: "M192.456,121.771v9.347h-1.77c-0.128-0.622-0.312-1.256-0.552-1.902 c-1.18,1.438-2.684,2.156-4.511,2.156c-2.158,0-3.838-0.771-5.038-2.314s-1.8-3.539-1.8-5.986c0-2.634,0.64-4.751,1.92-6.351 c1.281-1.6,3.02-2.399,5.218-2.399c1.842,0,3.328,0.518,4.46,1.551c1.131,1.035,1.821,2.412,2.072,4.133l-3.685,0.484 c-0.299-2.003-1.248-3.005-2.848-3.005c-1.051,0-1.845,0.475-2.382,1.424c-0.537,0.95-0.806,2.305-0.806,4.065 c0,1.697,0.291,2.994,0.873,3.891c0.581,0.896,1.409,1.346,2.484,1.346c0.694,0,1.314-0.227,1.86-0.68 c0.545-0.451,0.817-1.175,0.817-2.168h-3.114v-3.091H192.456z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    d: "M207.826,117.726h-8.378v3.394h6.193v3.114h-6.193v3.612h7.878v3.271H195.51v-16.543 h11.816V117.726z"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 211.5,
    cy: 115.8,
    r: 2.8,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    style: {
      transform: "translate(188.3px, 97.3px) scale(0.15)"
    },
    stroke: "#FFFFFF",
    d: "M152.597,124.561v6.557h-3.902v-16.543h7.271c1.341,0,2.418,0.156,3.229,0.467 c0.813,0.311,1.484,0.883,2.019,1.714c0.533,0.831,0.8,1.756,0.8,2.773c0,1.985-0.958,3.411-2.873,4.274l3.055,7.314h-4.282 l-2.54-6.557H152.597z M152.597,117.52v4.218h2.375c0.776,0,1.34-0.055,1.691-0.164c0.352-0.108,0.664-0.351,0.938-0.728 c0.275-0.375,0.412-0.805,0.412-1.29c0-0.46-0.137-0.872-0.412-1.236c-0.274-0.363-0.573-0.587-0.896-0.673 c-0.323-0.084-0.929-0.127-1.817-0.127H152.597z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLogo);
export default __webpack_public_path__ + "static/media/darkLogo.be3f46d7f5b25d9883adee127c7c2de4.svg";
export { ForwardRef as ReactComponent };